import { css } from '@emotion/react';
const FastGalleryContainerSelector = 'container';
const FastGalleryItemSelector = 'item';
const FastGalleryImageSelector = 'image';
export const containerSelector = ` .${FastGalleryContainerSelector}`;
export const itemSelector = ` .${FastGalleryItemSelector}`;
export const imageSelector = ` .${FastGalleryImageSelector}`;
const cssToJsObject = cssString => {
  const cssObject = {};
  const cssRules = cssString.match(/([^{]+)\{([^}]+)\}/g) || [];
  cssRules.forEach(rule => {
    const [selector, properties] = rule.split('{');
    const propertyPairs = properties.replace('}', '').trim().split(';').filter(Boolean);
    const styleObject = propertyPairs.reduce((acc, pair) => {
      const [property, value] = pair.split(':');
      if (property && value) {
        acc[property] = value.trim();
      }
      return acc;
    }, {});
    cssObject[selector.trim()] = styleObject;
  });
  return cssObject;
};
export const cssStringToBuilderReturnType = cssString => {
  return {
    cssString,
    cssObject: cssToJsObject(cssString)
  };
};
export const resetContainerCustomStyleSheet = (selector, additionalCss) => {
  const cssReset = css({
    [selector]: {
      display: 'block',
      gridTemplateColumns: 'unset',
      gridTemplateRows: 'unset',
      gridAutoFlow: 'unset',
      gridAutoColumns: 'unset',
      gridAutoRows: 'unset',
      rowGap: 'unset',
      flexWrap: 'nowrap',
      scrollSnapType: 'none',
      overflow: 'visible',
      scrollbarWidth: 'auto',
      gap: 0,
      height: 'auto',
      width: 'auto',
      columnGap: 'normal',
      ...additionalCss
    }
  }).styles;
  return cssStringToBuilderReturnType(cssReset);
};
export const resetItemCustomStyleSheet = (selector, additionalCss) => {
  const cssReset = css({
    [selector]: {
      gridColumn: 'auto',
      gridRow: 'auto',
      height: 'auto',
      width: 'auto',
      flex: 'unset',
      margin: 0,
      scrollSnapAlign: 'none',
      marginRight: 0,
      ...additionalCss
    },
    [`${selector}:nth-child(n)`]: {
      gridColumn: 'auto',
      gridRow: 'auto',
      height: 'auto',
      width: 'auto',
      flex: 'unset',
      margin: 0,
      scrollSnapAlign: 'none',
      marginRight: 0,
      ...additionalCss
    }
  }).styles;
  return cssStringToBuilderReturnType(cssReset);
};
export const resetImageCustomStyleSheet = (selector, additionalCss) => {
  const cssReset = css({
    [selector]: {
      display: 'block',
      width: 'auto !important',
      height: 'auto !important',
      img: {
        width: 'auto !important',
        height: 'auto !important',
        objectFit: 'fill',
        verticalAlign: 'baseline !important'
      },
      ...additionalCss
    }
  }).styles;
  return cssStringToBuilderReturnType(cssReset);
};
//# sourceMappingURL=commonUtils.js.map